export enum NoShowReasonFilter {
  ALL = 0,
  ALLOWED_ABSENCE = 1,
  NOT_ALLOWED_ABSENCE = 2,
  SICKNESS = 3,
  OTHER = 4,
}
